import { render, staticRenderFns } from "./RentObjects.vue?vue&type=template&id=7a821503&scoped=true&lang=pug"
import script from "./RentObjects.vue?vue&type=script&lang=js"
export * from "./RentObjects.vue?vue&type=script&lang=js"
import style0 from "./RentObjects.vue?vue&type=style&index=0&id=7a821503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a821503",
  null
  
)

export default component.exports